import type { Accessor } from "solid-js";

/**
 * Env-var accessors for the two independently-releasable anonymization
 * capabilities. The anonymous-CV feature ships first; the candidate report
 * ships in a later release. Each is a build-time kill switch: ON by default
 * (unset, or any value other than `"false"`), OFF only when
 * `VITE_*_ENABLED` is explicitly `"false"` — mirrored by the backend's own
 * env-var gate (see `requireFeatureFlag`).
 */

/** Anonymous branded CV (single, ATS single, ATS ZIP bundle). Ships first. */
export function useAnonymousCvEnabled(): Accessor<boolean> {
  return () => import.meta.env.VITE_ANONYMOUS_CV_ENABLED !== "false";
}

/** Candidate report PDF (active-search + ATS). Ships in a later release. */
export function useCandidateReportEnabled(): Accessor<boolean> {
  return () => import.meta.env.VITE_CANDIDATE_REPORT_ENABLED !== "false";
}
